import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Styles/StudentAttendanceHistory.css";
import Loader from "../../Components/Loader"


function StudentAttendanceHistory() {

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  const months = [
    "January", "February", "March", "April", "May", "June", "July", "August",
    "September", "October", "November", "December"
  ];


  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedDate, setSelectedDate] = useState(currentDay);
  const [selectedClass, setSelectedClass] = useState(""); 
  const [selectedSubject, setSelectedSubject] = useState(""); 
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [absentStudents, setAbsentStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getDaysInMonth = (month) => {
    const daysInMonth = new Date(currentDate.getFullYear(), month + 1, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, index) => index + 1);
  };

  const daysInMonth = getDaysInMonth(selectedMonth);
  const handleMonthChange = (e) => {
    setSelectedMonth(parseInt(e.target.value, 10));
    setSelectedDate(1); 
  };
  const handleDateChange = (e) => {
    setSelectedDate(parseInt(e.target.value, 10));
  };

  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);
  };
  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
  };
  const fetchClassesAndSubjects = async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("No authentication token found");
        return;
      }

      const response = await axios.get("https://api.uniums.com/api/faculty/faculty-classes-subjects", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data && response.data.data) {
        setClasses(response.data.data.classes);
        setSubjects(response.data.data.subjects);
        if (response.data.data.classes.length > 0) {
          setSelectedClass(response.data.data.classes[0]);
        }
        if (response.data.data.subjects.length > 0) {
          setSelectedSubject(response.data.data.subjects[0]);
        }
      } else {
        console.error("Unexpected API response format:", response.data);
        setError("Failed to fetch classes and subjects!");
      }
    } catch (error) {
      console.error("Error fetching classes and subjects:", error);
      setError("Error fetching classes and subjects!");
    } finally {
      setLoading(false);
    }
  };

  const fetchAttendanceData = async () => {
    setLoading(true);
    setError(null);

    try {
        const token = localStorage.getItem("authToken");
        if (!token) {
            console.error("No authentication token found");
            return;
        }

        const response = await axios.get("https://api.uniums.com/api/faculty/fetch-attendance", {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                selectedClass,
                selectedSubject,
                selectedMonth: selectedMonth + 1,  // Adding 1 because months are 0-based in JavaScript
                selectedDate,
                year: currentDate.getFullYear()
            }
        });

        if (response.data && response.data.data) {
            setAbsentStudents(response.data.data);
        } else {
            setAbsentStudents([]);
            setError("No attendance data available!");
        }
    } catch (error) {
        console.error("Error fetching attendance data:", error);
        setError("Error fetching attendance data!");
        setAbsentStudents([]);
    } finally {
        setLoading(false);
    }
};
  useEffect(() => {
    fetchClassesAndSubjects();
  }, []);

  useEffect(() => {
    if (selectedClass && selectedSubject) {
      fetchAttendanceData();
    }
  }, [selectedMonth, selectedDate, selectedClass, selectedSubject]);

  return (
    <div className="AbsentStudent_container">
      <h1>Students Attendance History</h1>

      {/* Filters */}
      <div className="filters">
        <div className="dp_filter">
          <label htmlFor="class">Select Class:</label>
          <select
            id="class"
            value={selectedClass}
            onChange={handleClassChange}
          >
            {classes.map((className, index) => (
              <option key={index} value={className}>
                {className}
              </option>
            ))}
          </select>
        </div>

        <div className="dp_filter">
          <label htmlFor="month">Select Month:</label>
          <select
            id="month"
            value={selectedMonth}
            onChange={handleMonthChange}
          >
            {months.map((month, index) => (
              <option key={index} value={index}>
                {month}
              </option>
            ))}
          </select>
        </div>
        <div className="dp_filter">
          <label htmlFor="date">Select Date:</label>
          <select
            id="date"
            value={selectedDate}
            onChange={handleDateChange}
          >
            {daysInMonth.map((day) => (
              <option key={day} value={day}>
                {day}
              </option>
            ))}
          </select>
        </div>
        <div className="dp_filter">
          <label htmlFor="subject">Select Subject:</label>
          <select
            id="subject"
            value={selectedSubject}
            onChange={handleSubjectChange}
          >
            {subjects.map((subject, index) => (
              <option key={index} value={subject}>
                {subject}
              </option>
            ))}
          </select>
        </div>

        {/* <div className="dp_filter">
          <button>Search</button>
        </div> */}
      </div>

      {/* {loading && <p>Loading attendance data...</p>} */}
      {loading && <Loader />}
      {error && <p className="error">{error}</p>}

      <div className="absent-students-list">
        {absentStudents.length === 0 ? (
          <p>No students are absent on {months[selectedMonth]} {selectedDate} for {selectedSubject} in {selectedClass}.</p>
        ) : (
          <table className="absent-students-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Employee Code</th>
                <th> Date</th>
                <th> Time</th>
                <th> Status</th>
              </tr>
            </thead>
            <tbody>
              {absentStudents.map((student, index) => (
                <tr key={index}>
                  <td>{student.name}</td>
                  <td>{student.employeeCode}</td>
                  <td>{student.date}</td>
                  <td>{student.time}</td>
                  <td>{student.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default StudentAttendanceHistory;
